































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import BInputLimited from '@/components/input_limited/BInputLimited.vue';
import Folder from '../../../models/Folder';
import FolderCommands from '../../../networking/Folder';
import FolderPermissions from '../FolderPermissions.vue';
import { BvModalEvent } from 'bootstrap-vue';

@Component({
    components: {
        BInputLimited,
        FolderPermissions
    },
	computed: {
		...mapGetters([
            'checkFolderEdit'
		])
    }
})
export default class FolderGearDropdown extends Vue
{
    @Prop(Object) readonly folder! : Folder;
    deleteModalTitleInput : string =  '';
    incorrectDeleteModalTitleInput = false;
    editName = '';

    showEditModal()
    {
        this.editName = this.folder.name;
        (this.$refs.editModal as any).show();
    }

    showPermsModal()
    {
        (this.$refs.permsModal as any).show();
    }

    get canEditFolders() : boolean
    {
        return (this as any).checkFolderEdit();
    }

    async confirmFolderDelete()
    {
        try
        {
            if (this.deleteModalTitleInput == this.folder.name)
			{
                await FolderCommands.raw.Folder_Delete({id: this.folder.id});
				this.hideDeleteModal();
			}
			else
			{
				this.incorrectDeleteModalTitleInput = true;
			}
        }
        catch(ex)
        {
            console.error(ex);
            alert('Failed to delete folder, please try again later.  If the issue persists, please submit a support ticket.')
        }
    }

    async confirmEditName(evt: BvModalEvent)
    {
        evt.preventDefault();
        try
        {
            await FolderCommands.raw.Folder_UpdateData({id: this.folder.id, name: this.editName, description: this.folder.description});
        }
        catch(ex)
        {
            console.error(ex);
            alert('Failed to edit folder name, please try again later.  If the issue persists, please submit a support ticket.')
        }
        
        if (this.$refs.editModal)
        {
            (this.$refs.editModal as any).hide();
        }
    }

    hideDeleteModal()
    {
        if (!this.$refs.deleteModal) return;
        (this.$refs.deleteModal as any).hide();
    }
}
